import { render, staticRenderFns } from "./ZoneManagement.vue?vue&type=template&id=4bafc070&scoped=true"
import script from "./ZoneManagement.vue?vue&type=script&lang=js"
export * from "./ZoneManagement.vue?vue&type=script&lang=js"
import style0 from "./ZoneManagement.vue?vue&type=style&index=0&id=4bafc070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafc070",
  null
  
)

export default component.exports